const AboutSection = () => {
    return (
        <>
            <div className="section-despre">
                <h1>Date generale despre raport și test</h1>
                <div className="subsection">
                    <div className="subsection-content">
                        <p>Acest raport a fost realizat în urma parcurgerii Testului Național de Alfabetizare
                            Matematică.</p>
                        <p>
                            Alfabetizarea matematică este definită (cf. OECD - PISA 2021 Mathematics Framework) ca fiind
                            capacitatea unei persoane de a raționa matematic și de a formula, folosi și interpreta
                            matematica pentru a rezolva probleme într-o varietate de contexte din lumea reală. Ea se
                            referă la un set de competențe care permit persoanelor să opereze cu valori numerice și
                            abstracte, măsurători, forme și dimensiuni, date și variabile în mod aplicat și versatil, în orice
                            aspect al vieții.
                        </p>
                        <p>
                            Testul Național de Alfabetizare Matematică (TNAM) a fost dezvoltat pe baza modelului care
                            stă la baza testului de matematică din cadrul NAEP (National Assessment of Educational
                            Progres), care este testul național folosit în SUA pentru urmărirea progresului elevilor și
                            care se aplică în clasele 4, 8 și 12.
                        </p>
                        <p>
                            Competențele de alfabetizare matematică sau numerație sunt evaluate în TNAM pe cinci mari
                            categorii de conținut:
                        </p>
                        <ol>
                            <li>Proprietăți ale numerelor și Operații cu numerele</li>
                            <li>Măsurare</li>
                            <li>Geometrie</li>
                            <li>Analiza datelor, Statistică și Probabilități</li>
                            <li>Algebră</li>
                        </ol>
                        <p>
                            Acest test este diferit de testele de matematică, întrucât se referă la capacitatea de a
                            opera cu numere, măsurători, caracteristici ale obiectelor, date și variabile în situații
                            aplicate, nu doar teoretice. Alfabetizarea matematică se referă la stăpânirea acestor concepte pentru
                            a deservi unor scopuri din viața reală. În acest sens, TNAM este un instrument de evaluare
                            independent de programa școlară, dar este totodată potrivit pentru vârsta elevului testat.
                        </p>
                    </div>
                </div>
                <div className="subsection">
                    <h3>Componența și utilitatea raportului</h3>
                    <div className="subsection-content">
                        <p>
                            Acest raport conține informații care pot fi utile pentru elevul testat, părinții/familia sa,
                            respectiv profesori sau orice altă persoană implicată în educația elevului. Mai specific, în
                            acest raport pot fi găsite următoarele informații:
                        </p>
                        <p>
                            <strong>Secțiunea introductivă</strong> este cea pe care o parcurgeți acum și care conține
                            informații generale despre TNAM și raportul rezultat în urma testării.
                        </p>
                        <p>
                            <strong>Definirea domeniilor de conținut</strong> este realizată în termeni ușor de înțeles
                            chiar și de către elevi și este de natură să ofere context în interpretarea rezultatelor.
                        </p>
                        <p>
                            <strong>Graficele cu scoruri</strong> prezintă scorul elevului într-un sistem de centile.
                            Scorul centilă arată modul în care orice elev testat se compară cu toți ceilalți elevi din
                            România care sunt în același an școlar cu acesta. De exemplu, pentru un elev care se află în a 60-a
                            centilă, vom spune că 40% dintre elevii din România (de aceeași vârstă sau din aceeași
                            clasă) au performanțe mai bune decât a sa, în timp ce 60% au performanțe mai slabe sau egale cu cea a
                            elevului testat. În același timp, un elev care se află la centila 90 are doar 10% din populația școlară
                            comparabilă cu performanță mai bună decât a sa, iar 90% au performanțe mai slabe, acesta
                            fiind, așadar, un scor foarte mare. În urma testării, elevul va primi scorul pentru toate componentele
                            evaluate, atât cele 5 categorii largi de conținut, cât și subdimensiunile acestora.
                        </p>
                        <p>
                            Pe lângă punctaj, raportul conține informații și despre categoria de performanță în care se
                            încadrează elevul testat pentru cele 5 categorii largi de conținut. Categoriile de scoruri
                            sunt următoarele: Nivel de bază (scor 1-40), Nivel avansat (scor 41-70) și Nivel expert
                            (scor 71-100). Categoria de performanță în care se încadrează punctajul elevului testat este
                            evidențiată și conține descrieri generale legate de cunoștințele și abilitățile sale.
                        </p>
                        <p>
                            Deși TNAM este un instrument de evaluare robust, pentru decizii majore legate de educația
                            elevului, se recomandă întotdeauna coroborarea de informații din surse multiple.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutSection;
